import { logShutteringEvent } from '../firebase'

// Analytics utility functions for quotation and table configuration events
export const trackQuotationEvent = (eventName: string, additionalParams: Record<string, any> = {}) => {
  const baseParams = {
    feature: 'quotation',
    timestamp: new Date().toISOString(),
    ...additionalParams
  }
  
  logShutteringEvent(eventName, baseParams)
}

export const trackTableConfigurationEvent = (eventName: string, additionalParams: Record<string, any> = {}) => {
  const baseParams = {
    feature: 'table_configuration',
    timestamp: new Date().toISOString(),
    ...additionalParams
  }
  
  logShutteringEvent(eventName, baseParams)
}

export const trackTutorialEvent = (eventName: string, additionalParams: Record<string, any> = {}) => {
  const baseParams = {
    feature: 'tutorial',
    timestamp: new Date().toISOString(),
    ...additionalParams
  }
  
  logShutteringEvent(eventName, baseParams)
}

export const trackBlogEvent = (eventName: string, additionalParams: Record<string, any> = {}) => {
  const baseParams = {
    feature: 'blog',
    timestamp: new Date().toISOString(),
    ...additionalParams
  }
  
  logShutteringEvent(eventName, baseParams)
}

// Performance tracking
export const trackPerformance = (action: string, duration: number, additionalParams: Record<string, any> = {}) => {
  const params = {
    action,
    duration_ms: duration,
    ...additionalParams
  }
  
  logShutteringEvent('PERFORMANCE_METRIC', params)
}

// Error tracking
export const trackError = (errorType: string, errorMessage: string, additionalParams: Record<string, any> = {}) => {
  const params = {
    error_type: errorType,
    error_message: errorMessage,
    ...additionalParams
  }
  
  logShutteringEvent('ERROR_OCCURRED', params)
}

// User behavior tracking
export const trackUserBehavior = (action: string, additionalParams: Record<string, any> = {}) => {
  const params = {
    action,
    ...additionalParams
  }
  
  logShutteringEvent('USER_BEHAVIOR', params)
}
